import React from 'react'

function Icon({i}) {
  return <i className={`fa-solid ${i}`}></i>
}

export default Icon